import type { CSSProperties, ReactNode } from 'react'
import { Toaster as SonnerToaster, toast, type ExternalToast } from 'sonner'

import { cn } from '@/lib/utils'
import type { CSSVariableStyle } from '@/lib/css-variables'

const ACTION_REQUIRED_TOAST_STYLE: CSSVariableStyle = {
  '--status-info-background': 'var(--brand-mint)',
  '--status-info-border': 'var(--brand-periwinkle)',
  '--status-info-foreground': 'var(--brand-charcoal)',
}

const ACTION_REQUIRED_BUTTON_STYLE: CSSProperties = {
  backgroundColor: 'var(--action)',
  color: 'var(--action-foreground)',
}

export function Toaster() {
  return (
    <SonnerToaster
      closeButton
      style={{ fontFamily: 'var(--font-sans)' }}
      toastOptions={{
        classNames: {
          toast:
            '!rounded-md !border-border !bg-card !text-foreground !shadow-lg dark:!shadow-none',
          title: '!font-semibold',
          description: '!text-current',
          success:
            '!border-status-success-border !bg-status-success-background !text-status-success-foreground [&_svg]:!text-status-success-foreground',
          warning:
            '!border-status-warning-border !bg-status-warning-background !text-status-warning-foreground [&_svg]:!text-status-warning-foreground',
          error:
            '!border-status-destructive-border !bg-status-destructive-background !text-status-destructive-foreground [&_svg]:!text-status-destructive-foreground',
          info: '!border-status-info-border !bg-status-info-background !text-status-info-foreground [&_svg]:!text-status-info-foreground',
          actionButton:
            '!rounded-full !bg-action !px-3 !font-medium !text-action-foreground hover:!bg-action-hover',
          cancelButton:
            '!rounded-full !border !border-border !bg-card !px-3 !font-medium !text-foreground hover:!bg-muted',
          closeButton: '!border-border !bg-card !text-muted-foreground hover:!text-foreground',
        },
      }}
    />
  )
}

export function showActionRequiredToast(message: ReactNode, options: ExternalToast = {}) {
  return toast.info(message, {
    ...options,
    closeButton: false,
    dismissible: false,
    style: ACTION_REQUIRED_TOAST_STYLE,
    actionButtonStyle: ACTION_REQUIRED_BUTTON_STYLE,
  })
}

export function stackToastAction(options: ExternalToast = {}): ExternalToast {
  const classNames = options.classNames || {}

  return {
    ...options,
    classNames: {
      ...classNames,
      toast: cn(
        '!grid !grid-cols-[auto_minmax(0,1fr)] !items-start !gap-x-2 !gap-y-3',
        classNames.toast
      ),
      icon: cn('!col-start-1 !row-start-1 !mt-0.5', classNames.icon),
      content: cn('!col-start-2 !row-start-1 !min-w-0', classNames.content),
      actionButton: cn(
        '!col-start-2 !row-start-2 !m-0 !w-fit max-w-full whitespace-normal text-left',
        classNames.actionButton
      ),
    },
  }
}
